function NotFound() {
  return (
    <div className="flex-grow bg-slate-900 text-slate-200 flex flex-col items-center justify-center text-center py-20">
      <div className="font-mono font-bold text-teal-300 md:text-8xl text-6xl mb-4 tracking-widest">
        404
      </div>
      <div className="font-sans font-medium md:text-3xl text-2xl text-slate-200 mb-2">
        Page Not Found
      </div>
      <div className="font-sans text-slate-400 md:text-lg text-base mb-8">
        Looks like this page drifted out of orbit.
      </div>
      <a
        href="/home"
        className="inline-block border-2 border-teal-300 px-6 py-2 font-mono text-teal-300 shadow-teal-300 shadow-md hover:shadow-sm hover:shadow-teal-300"
      >
        Go Home
      </a>
    </div>
  );
}

export default NotFound;
